import maplibregl from "maplibre-gl";
import * as pmtiles from "pmtiles";
import "maplibre-gl/dist/maplibre-gl.css";


// On document ready with vanilla JS
    console.log('TEST');
document.addEventListener('DOMContentLoaded', function () {
    // If element with ID 'map' exists
    if (document.querySelector('.slider .google-map-top-space #map-canvas')) { // Todo CSS Selektor anpassen bei anderen Designs
        // Initialize Map Libre JS
        const mapElement = document.querySelector('.slider .google-map-top-space #map-canvas'); // Todo CSS Selektor anpassen bei anderen Designs
        const tilesUrl = mapElement.getAttribute('data-tiles-url');
        const mapMarkerEnabled = mapElement.getAttribute('data-map-marker-enabled') === 'true';
        const mapMarkerColorCode = mapElement.getAttribute('data-map-marker-color-code');
        const forceDefaultMarker = mapElement.getAttribute('data-force-default-map-marker') === 'true';
        const zoom = parseInt(mapElement.getAttribute('data-zoom'));
        const rawMarkers = JSON.parse(mapElement.getAttribute('data-markers') || '[]');
        // Nur Marker mit gültigen Koordinaten verwenden
        const markers = rawMarkers.filter(function (m) {
            const lat = parseFloat(m.lat);
            const lng = parseFloat(m.lng);
            return !isNaN(lat) && !isNaN(lng);
        }).map(function (m) {
            return { lat: parseFloat(m.lat), lng: parseFloat(m.lng), icon: m.icon || '' };
        });

        if (markers.length === 0) {
            return;
        }

        const protocol = new pmtiles.Protocol();
        maplibregl.addProtocol("pmtiles", protocol.tile);

        const source = new pmtiles.PMTiles(tilesUrl);
        protocol.add(source);

        // Kartenmittelpunkt: bei einem Marker direkt, sonst Mittelpunkt aller Marker
        const centerLng = markers.reduce((sum, m) => sum + m.lng, 0) / markers.length;
        const centerLat = markers.reduce((sum, m) => sum + m.lat, 0) / markers.length;

        const map = new maplibregl.Map({
            container: mapElement,
            style: map_style,
            center: [centerLng, centerLat],
            zoom: zoom,
            attributionControl: false
        });

        map.addControl(new maplibregl.AttributionControl({
            compact: true,
        }), 'top-right'); // Todo ggf. andere Ecke bei anderen Designs

        if (mapMarkerEnabled) {
            const iconMap = {
                buero:     templateurl + '/assets/map-marker-buero.svg',
                halle:     templateurl + '/assets/map-marker-halle.svg',
                gemischt:  templateurl + '/assets/map-marker-gemischt.svg',
            };
            const defaultImageUrl = templateurl + '/assets/map-marker-neu.png'; // Todo Mapmarker anpassen bei anderen Designs

            console.log('[Map] mapMarkerEnabled:', mapMarkerEnabled);
            console.log('[Map] forceDefaultMarker:', forceDefaultMarker);
            console.log('[Map] markers:', JSON.stringify(markers));

            markers.forEach(function (markerData) {
                const lng = markerData.lng;
                const lat = markerData.lat;
                const resolvedIcon = iconMap[markerData.icon] || defaultImageUrl;
                console.log('[Map] Marker:', lat, lng, '| icon field:', markerData.icon, '| resolved:', resolvedIcon);

                if (forceDefaultMarker) {
                    if (mapMarkerColorCode) {
                        new maplibregl.Marker({ color: mapMarkerColorCode })
                            .setLngLat([lng, lat])
                            .addTo(map);
                    } else {
                        new maplibregl.Marker()
                            .setLngLat([lng, lat])
                            .addTo(map);
                    }
                } else {
                    const imageUrl = iconMap[markerData.icon] || defaultImageUrl;

                    const el = document.createElement('div');
                    el.className = 'custom-marker';
                    el.style.backgroundImage = `url(${imageUrl})`;
                    el.style.width = '74px'; // Todo Mapmarkergröße anpassen bei anderen Designs
                    el.style.height = '98px';
                    el.style.backgroundSize = '100%';

                    new maplibregl.Marker({ element: el, anchor: 'bottom' })
                        .setLngLat([lng, lat])
                        .addTo(map);
                }
            });

            // Bei mehreren Markern Karte so einzoomen, dass alle sichtbar sind
            if (markers.length > 1) {
                const bounds = new maplibregl.LngLatBounds();
                markers.forEach(function (m) {
                    bounds.extend([m.lng, m.lat]);
                });
                map.fitBounds(bounds, { padding: 120 });
            }
        }
    }
});
